function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.77 2.23c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.75 9.99l-.52 8.26C21.1 20.31 20 22 17.24 22H6.76c-.59 0-1.1-.08-1.54-.22L20.25 6.75c.98.73 1.59 1.92 1.5 3.24zM18 6L3.48 20.52c-.45-.63-.66-1.42-.71-2.27l-.52-8.26A3.753 3.753 0 016 6c.61 0 1.17-.35 1.45-.89l.72-1.45C8.63 2.75 9.83 2 10.86 2h2.29c1.02 0 2.22.75 2.68 1.66l.72 1.45c.28.54.84.89 1.45.89z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 10.75h-3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75zm3.07.68l-3.89 3.89a3.372 3.372 0 013.89-3.89zm2.81 3.32A3.38 3.38 0 0112 18.12c-.87 0-1.66-.33-2.25-.87l4.75-4.75c.55.59.88 1.38.88 2.25z"
})));